export const _get = (obj: any, path: string) => {
  const keys = path.split('.');
  let newObj = JSON.parse(JSON.stringify(obj));
  for (let i = 0; i < keys.length; i++) {
    if (typeof newObj?.[keys[i]] === undefined) return newObj?.[keys[i]];
    newObj = newObj?.[keys[i]];
  }
  return newObj;
};
